import {
  DEFAULT_BUDGET_CURRENCY,
  type AmountDto,
  type BulkUpsertBudgetsDto,
  type BulkUpsertBudgetValues,
  type SingleBudget,
  type SingleBudgetDto,
  type UpdateBudgetDto,
  type UpdateBudgetValues,
  type UpsertBudgetDto,
  type UpsertBudgetValues,
} from './budget.dto';

// Cents are always sent explicitly ("1200.00"), matching how the wallet service stores amounts.
const toAmountDto = (planned: number, currency = DEFAULT_BUDGET_CURRENCY): AmountDto => ({
  number: planned.toFixed(2),
  currency,
});

export const mapDtoToBudget = ({
  service_id,
  expenses_category,
  planned_budget,
  created_at,
  updated_at,
  ...values
}: SingleBudgetDto): SingleBudget => ({
  ...values,
  serviceId: service_id,
  expensesCategory: expenses_category,
  plannedBudget: {
    number: planned_budget?.number ?? '0',
    currency: planned_budget?.currency ?? DEFAULT_BUDGET_CURRENCY,
  },
  createdAt: created_at,
  updatedAt: updated_at,
});

export const mapUpsertBudgetToDto = ({
  expensesCategory,
  plannedBudget,
  year,
  currency,
}: UpsertBudgetValues): UpsertBudgetDto => ({
  expenses_category: expensesCategory,
  planned_budget: toAmountDto(plannedBudget, currency),
  year,
});

export const mapUpdateBudgetToDto = ({
  plannedBudget,
  currency,
}: UpdateBudgetValues): UpdateBudgetDto => ({
  planned_budget: toAmountDto(plannedBudget, currency),
});

export const mapBulkUpsertBudgetsToDto = ({
  budgets,
  currency,
}: BulkUpsertBudgetValues): BulkUpsertBudgetsDto => ({
  budgets: budgets.map((row) => ({
    expenses_category: row.expensesCategory,
    planned_budget: toAmountDto(row.plannedBudget, currency),
  })),
});
